export default "__VITE_ASSET__454698c5__"